import { DataAttributeDefinitions } from 'scrivito'

import { pisaTimerecordBudgetDataClass } from './Pisa/pisaTimerecordBudgetDataClass'

const attributes: DataAttributeDefinitions = {}

export const TimerecordBudget = pisaTimerecordBudgetDataClass(attributes)
